module.exports = __webpack_public_path__ + "static/media/prenotazione_biglietti_eventi.92901705.png";